import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted fonts — no third-party font host at runtime (Iran-safe).
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/500.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';
import '@fontsource/newsreader/400.css';
import '@fontsource/newsreader/500.css';
import 'vazirmatn/Vazirmatn-font-face.css';

import './styles/tokens.css';
import './styles/base.css';

import { loadRuntimeConfig } from './core/config';
import { App } from './app/App';

const root = createRoot(document.getElementById('root')!);

function renderConfigError() {
  // Pre-provider failure state: bilingual by necessity, no dependencies.
  root.render(
    <div style={{ padding: 40, fontFamily: 'system-ui, sans-serif', maxInlineSize: 480 }}>
      <h1 style={{ fontSize: 18 }}>پیکربندی بارگذاری نشد · Configuration could not be loaded</h1>
      <p style={{ color: '#54504A', fontSize: 14 }}>
        config.json در دسترس نیست. · The deployment&apos;s config.json is unreachable.
      </p>
      <button
        type="button"
        style={{ minBlockSize: 44, paddingInline: 18, fontSize: 14, cursor: 'pointer' }}
        onClick={() => window.location.reload()}
      >
        تلاش دوباره · Try again
      </button>
    </div>,
  );
}

loadRuntimeConfig()
  .then(() => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch(renderConfigError);
